// import { store } from './../store'
import { MobxLitElement } from '@adobe/lit-mobx'
import { html, TemplateResult } from 'lit'
import { customElement } from 'lit/decorators.js'

@customElement('pool-page')
export default class PoolPage extends MobxLitElement {
  _active = false
  _menuColor = 'black'
  _observerOptions = { root: this, rootMargin: '0px 0px', threshold: [0, 1] }
  _observer = <IntersectionObserver | null>null

  set active(state: boolean) {
    this._active = state
  }

  get active() {
    return this._active
  }

  set menu(color: string) {
    this._menuColor = color
  }

  get menu() {
    return this._menuColor
  }

  get observerOptions() {
    return this._observerOptions
  }

  set observer(observerObj) {
    this._observer = observerObj
  }

  get observer() {
    return this._observer
  }

  constructor() {
    super()
  }

  public render(): TemplateResult {
    return html`
      <slot name="main"></slot>
      <aside id="controller"></aside>
   `
  }
}
